
import {defineComponent, PropType} from "vue";
import {BoxShadowValueRestDto, ColorSolidRestDto} from "@/api/pharma-cms-content-page/models";
import {BoxShadowValueRestDtoModel} from "@/models/api/pharma-cms-content-page/BoxShadowValueRestDtoModel";
import {CssUnitEnum} from "@/api/enums/css-unit-enum";
import {ComponentMixin} from "@/components/base/ComponentMixin";
import GenericComponentWrapper from "@/components/base/GenericComponentWrapper.vue";
import CssDimensionEditor from "@/components/layouts/content-pages/wysiwyg/misc/CssDimensionEditor.vue";
import ColorSolidEditor from "@/components/layouts/content-pages/wysiwyg/misc/ColorSolidEditor.vue";
import InputCheckboxBoolean from "@/components/UI/InputCheckboxBoolean.vue";

export default defineComponent({
  name: "BoxShadowLayerDetail",
  mixins: [ComponentMixin],
  components: {GenericComponentWrapper, CssDimensionEditor, ColorSolidEditor, InputCheckboxBoolean},
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Object as PropType<BoxShadowValueRestDto>,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.componentUI.setReady();
  },
  data() {
    return {
      localDto: BoxShadowValueRestDtoModel.createWithDefaults() as BoxShadowValueRestDto,
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newValue: BoxShadowValueRestDto) {
        this.localDto = BoxShadowValueRestDtoModel.cloneFrom(newValue);
      },
    },
  },
  computed: {
    CssUnitEnum() {
      return CssUnitEnum;
    },
  },
  methods: {
    onColorChanged(newValue: ColorSolidRestDto | null): void {
      this.localDto.color = newValue;
      this.emitModelChanged();
    },
    emitModelChanged(): void {
      this.$emit('update:modelValue', this.localDto);
    },
  },
});
